// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"af515d54","180":"0b2baa26","208":"72870024","689":"670e77f8","695":"0ecdac59","774":"05acca22","787":"71669281"}[chunkId] + ".chunk.js";
};